import locale from '~/utils/locale'

export default locale.create<{
    selectionOptions: {
        all: string
        none: string
        invert: string
    }
}>()
